export const SCOPES = {
  APPLICATION_READ: 'sa.application:read',
  APPLICATION_WRITE: 'sa.application:write',
  MCP_READ: 'sa.mcp:read',
  MCP_WRITE: 'sa.mcp:write',
  PROXY_READ: 'sa.proxy:read',
  PROXY_WRITE: 'sa.proxy:write',
  ORGANIZATION_READ: 'sa.organization:read',
  ORGANIZATION_WRITE: 'sa.organization:write',
  ORG_LINK_READ: 'sa.org_link:read',
  ORG_LINK_WRITE: 'sa.org_link:write',
  ACCESS_REQUEST_READ: 'sa.access_request:read',
  ACCESS_REQUEST_WRITE: 'sa.access_request:write',
  PLATFORM_REQUEST_READ: 'sa.platform_request:read',
  PLATFORM_REQUEST_WRITE: 'sa.platform_request:write',
  MONITORING_READ: 'sa.monitoring:read',
  MONITORING_WRITE: 'sa.monitoring:write',
  DASHBOARD_READ: 'sa.dashboard:read',
} as const

export type ScopeKey = keyof typeof SCOPES
export type ScopeValue = (typeof SCOPES)[ScopeKey]

export const ALL_SA_SCOPES = Object.values(SCOPES).filter((s) => s.startsWith('sa.'))
